export const toFiniteNumberOrNull = (value) => {
  if (value == null) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const formatScore = (value, { decimals = 3 } = {}) => {
  const n = toFiniteNumberOrNull(value);
  if (n === null) return null;
  return n.toFixed(decimals);
};
